import { useTranslation } from 'react-i18next'

function splitVerifiedLabel(full: string): { brand: string; tag: string } {
  const trimmed = full.trim()
  const space = trimmed.indexOf(' ')
  if (space <= 0) return { brand: 'reDevicer', tag: trimmed || 'Verified' }
  return { brand: trimmed.slice(0, space), tag: trimmed.slice(space + 1).trim() }
}

export default function ListingCardVerifiedBadge() {
  const { t } = useTranslation()
  const full = t('trust.report.verifiedBadge')
  const { brand, tag } = splitVerifiedLabel(full)

  return (
    <span className="listing-card-verified-badge" role="status" aria-label={full}>
      <span className="listing-card-verified-badge__edge" aria-hidden="true" />
      <span className="listing-card-verified-badge__mark" aria-hidden="true">
        <img src="/logo-mark.png?v=4" alt="" decoding="async" draggable={false} />
      </span>
      <span className="listing-card-verified-badge__text">
        <span className="listing-card-verified-badge__brand">{brand}</span>
        <span className="listing-card-verified-badge__tag">{tag}</span>
      </span>
    </span>
  )
}
